import Highcharts from "highcharts";
import { toFixed } from "src/services/utils";

export const baseBeautifulTooltip = (valueFormat, isPercent = false, xFormat = (x) => x) => {
  return {
    tooltip: {
      useHTML: true,
      style: {
        display: "block",
      },
      formatter: function () {
        const points = this.points;
        let data = "";
        let x = null;
        for (let config of points) {
          if (!x) x = config.x;
          const color = config.color;
          let yValue = "";
          if (isPercent) {
            if (config.percentage < 0.0001) yValue = `${valueFormat(0)} (0%)`;
            else yValue = `${valueFormat(config.y)} (${toFixed(config.percentage, 2)}%)`;
          } else yValue = valueFormat(config.y);
          data += `<br /><div class="scoring-chart-tooltip-container">\
          <div class="scoring-chart-tooltip-circle" style="background:${color}"></div>\
          <span>${config.series.name}</span>:&nbsp;<b>${yValue}</b></div>`;
        }
        data = `<div class="scoring-chart-tooltip-x">${xFormat(x)}</div>` + data;
        return data;
      },
    },
  };
};

export const powerfulTooltip = (titleFormatter, valueFormatter, headerFormatter = (x) => x) => {
  return {
    tooltip: {
      useHTML: true,
      style: {
        display: "block",
      },
      formatter: function () {
        const points = this.points;
        let data = "";
        let x = null;
        for (let point of points) {
          if (!x) x = point.x;
          const color = point.color;
          let title = titleFormatter(point);
          let value = valueFormatter(point);
          data += `<br /><div class="scoring-chart-tooltip-container">\
          <div class="scoring-chart-tooltip-circle" style="background:${color}"></div>\
          <span>${title}</span>:<b>&nbsp;${value}</b></div>`;
        }
        data = `<div class="scoring-chart-tooltip-x">${headerFormatter(x)}</div>` + data;
        return data;
      },
    },
  };
};

export const beautifulTooltip = (valueFormat, isPercent = false, dateFormat = "%b %e, %Y, %k:%M") => {
  return baseBeautifulTooltip(valueFormat, isPercent, (date) => `${Highcharts.dateFormat(dateFormat, date)}`);
};

export const powerfulDateTooltip = (titleFormatter, valueFormatter, dateFormat = "%b %e, %Y, %k:%M") => {
  return powerfulTooltip(titleFormatter, valueFormatter, (date) => `${Highcharts.dateFormat(dateFormat, date)}`);
};
